import React from "react";
import { MODEL_CONFIG } from "../config/models";

const ModelSelector = ({ selected, onSelect, onBack, backSlot }) => {
  const backStyles = {
    display: "inline-block",
    background: "rgba(0,0,0,0.75)",
    color: "var(--brand-sand, #e9dace)",
    border: "1px solid rgba(192,46,9,0.35)",
    padding: "8px 16px",
    borderRadius: "20px",
    cursor: "pointer",
    fontSize: "13px",
    fontFamily: "var(--font-body, Inter, system-ui, sans-serif)",
    backdropFilter: "blur(10px)",
    textDecoration: "none",
  };

  return (
    <div
      style={{
        position: "fixed",
        top: "16px",
        left: "50%",
        transform: "translateX(-50%)",
        display: "flex",
        gap: "8px",
        zIndex: 999,
        flexWrap: "wrap",
        justifyContent: "center",
        padding: "0 16px",
      }}
    >
      {backSlot}
      {!backSlot && onBack && (
        <button type="button" onClick={onBack} style={backStyles}>
          ← Volver
        </button>
      )}

      {Object.entries(MODEL_CONFIG).map(([key, config]) => (
        <button
          key={key}
          onClick={() => onSelect(key)}
          style={{
            background: selected === key ? "var(--brand-primary, #c02e09)" : "rgba(0,0,0,0.75)",
            color: "#fff",
            border: `2px solid ${
              selected === key
                ? "var(--brand-primary, #c02e09)"
                : "rgba(255,255,255,0.25)"
            }`,
            padding: "8px 18px",
            borderRadius: "20px",
            cursor: "pointer",
            fontSize: "13px",
            fontFamily: "var(--font-body, Inter, system-ui, sans-serif)",
            fontWeight: selected === key ? "700" : "400",
            backdropFilter: "blur(10px)",
            transition: "all 0.2s ease",
            transform: selected === key ? "scale(1.05)" : "scale(1)",
          }}
        >
          {config.label}
        </button>
      ))}
    </div>
  );
};

export default ModelSelector;
